import React from 'react';

export class OccupationInfo extends React.Component{

    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }
    
    handleChange(event){
        this.props.handleChange(event);
    }

    render(){
        const { occpIncomeSrc ,occpWorkNature ,occpPosition, occpCompanyName , occpAnnualIncome  } = this.props ; 
        
        return (
            <React.Fragment>
                <div className="columns m-t-xs">
                    <div className="column is-6">
                        <label className="label is-small">Income Source</label>
                        <div className="select is-fullwidth">
                            <select value={occpIncomeSrc} name="occpIncomeSrc" onChange={this.handleChange}>
                                <option>Select Source of Income</option>
                                <option value="Salary">Salary</option>
                                <option value="Pension">Pension</option>
                                <option value="Investment">Investment</option>
                            </select>
                        </div>
                    </div>
                    <div className="column is-6">
                        <label className="label is-small">Nature of Work</label>
                        <input className="input" value={occpWorkNature} name="occpWorkNature" type="text" placeholder="Nature of Work" onChange={this.handleChange}/>
                    </div>
                </div>
                <div className="columns">
                    <div className="column is-6">
                        <label className="label is-small">Position</label>
                        <input className="input" value={occpPosition} name="occpPosition" type="text" placeholder="Position" onChange={this.handleChange}/>
                    </div>
                    <div className="column is-6">
                        <label className="label is-small">Company Name</label>
                        <input className="input" value={occpCompanyName} name="occpCompanyName" type="text" placeholder="Company Name" onChange={this.handleChange}/>
                    </div>
                </div>
                <div className="columns">
                    <div className="column is-12">
                        <label className="label is-small">Annual Income</label>
                        <div className="select is-fullwidth">
                            <select value={occpAnnualIncome} name="occpAnnualIncome" onChange={this.handleChange}>
                                <option value="">Select Annual Income (USD)</option>
                                <option value="Less than 20,000">Less than 20,000</option>
                                <option value="20,001 - 40,000">20,001 - 40,000</option>
                                <option value="40,001 - 60,000">40,001 - 60,000</option>
                                <option value="60,001 - 80,000">60,001 - 80,000</option>
                                <option value="Above 80,001">Above 80,001</option>
                            </select>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Views/ProfilePage/OccupationInfo.jsx